import { Record as record } from 'immutable';

import { construct, fields } from '../helpers/LinkMapper';

const defaults = {
    utn: null,
    issuer: null,
    state: null,
    nlc: null,
    orderId: null,
    ticketId: null
};

class UtnDetail extends record(defaults) {
    static fromJSON(json = {}) {
        return construct(UtnDetail, json, {
            utn: fields.string,
            issuer: fields.string,
            state: fields.string,
            nlc: fields.string,
            orderId: fields.number,
            ticketId: fields.number
        });
    }
}

export default UtnDetail;
